import { apiWrapper } from "@/services/api";

export const getDemandArea = async () => {
  let response;
  try {
    response = await apiWrapper("GET", `/demand-booking-services`);
    console.log("getDemandArea response.data :>> ", response.data);
  } catch (err) {
    console.log('ERROR"" getDemandArea():', err);
    throw err;
  }
  return response.data;
};
